<template>
  <div>
    <p>
      Siehe hier in welchem Raum du dich befindest.<br>
      Je nachdem in welchem Raum du bist, kannst du andere Geräte finden.
    </p>
    <p>
      Wir starten im lokalem Netzwerk.<br>
      Mehr zu den Räumen gibts gleich.
    </p>
  </div>
</template>

<script>
  import {switchRoom} from './step-utils';


  const component = {
    name: 'StepRoomCurrent'
  };


  export const StepRoomCurrent = {
    target: '.topbar .room-name',
    before: async () => {
      await switchRoom('local');
    },
    header: 'Willkommen bei XidrasTransfer!',
    content: component
  };


  export default component;
</script>
